import React from 'react';
import '../styles/Legal.css';
import SEO from '../components/SEO';

const HIPAA = () => {
  return (
    <div className="legal-page">
      <SEO
        title="HIPAA Compliance Notice"
        description="CADENCE Medical Consulting's HIPAA Notice of Privacy Practices. How we protect your Protected Health Information (PHI) and your rights as a patient."
        path="/hipaa"
      />
      <div className="container">
        <div className="legal-content">
          <h1 className="heading-hero">HIPAA Compliance Notice</h1>
          <p className="legal-updated">Notice of Privacy Practices</p>

          <section className="legal-section">
            <h2 className="heading-2">Our Duties</h2>
            <p className="body-large">
              We are required by law to maintain the privacy of your Protected Health Information (PHI) and to provide you with this notice of our legal duties and privacy practices.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="heading-2">Uses and Disclosures of Your PHI</h2>

            <div className="legal-subsection">
              <h3 className="heading-3">For Treatment, Payment, & Operations</h3>
              <p className="body-medium">
                We may use your PHI to provide our advocacy services (Treatment), to bill and collect payment (Payment), and for our internal quality assessments (Operations).
              </p>
            </div>

            <div className="legal-subsection">
              <h3 className="heading-3">With Your Authorization</h3>
              <p className="body-medium">
                We will not use or disclose your PHI for any other purpose (e.g., marketing) without your written authorization. You may revoke this authorization in writing at any time.
              </p>
            </div>

            <div className="legal-subsection">
              <h3 className="heading-3">Without Authorization</h3>
              <p className="body-medium">
                We may use or disclose your PHI without authorization where permitted or required by law (e.g., public health reporting, judicial proceedings).
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2 className="heading-2">Your Rights Regarding Your PHI</h2>
            <p className="body-large">You have the right to:</p>
            <ul className="legal-list">
              <li>Inspect and copy your PHI.</li>
              <li>Request an amendment to your PHI.</li>
              <li>Receive an accounting of certain disclosures.</li>
              <li>Request restrictions on certain uses and disclosures.</li>
              <li>Request confidential communications.</li>
              <li>Receive a paper copy of this notice.</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2 className="heading-2">Breach Notification</h2>
            <p className="body-large">
              We are required by law to notify you in the event of a breach of your unsecured PHI.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="heading-2">Complaints</h2>
            <p className="body-large">
              If you believe your privacy rights have been violated, you may file a complaint with us at{' '}
              <a href="mailto:CADENCE@cadencemedicalconsulting.com">CADENCE@cadencemedicalconsulting.com</a>{' '}
              or with the Secretary of the U.S. Department of Health and Human Services.
            </p>
            <p className="body-medium" style={{ marginTop: '1rem' }}>
              <strong>You will not be retaliated against for filing a complaint.</strong>
            </p>
          </section>

          <section className="legal-section contact-section">
            <h2 className="heading-2">Questions About Your Privacy?</h2>
            <p className="body-large">
              If you have any questions about this Notice or our privacy practices, please contact us at{' '}
              <a href="mailto:CADENCE@cadencemedicalconsulting.com">CADENCE@cadencemedicalconsulting.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default HIPAA;